"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.simplePhoneNormalizer = void 0;
const mock_small_phone_json_1 = __importDefault(require("./mock-small-phone.json"));
const mock_big_phone_json_1 = __importDefault(require("./mock-big-phone.json"));
/**
 * normalizador del modulo MODULO_SIMPLEPHONE
 * @param {object} fields
 * @returns
 */
const simplePhoneNormalizer = (data) => {
    var _a, _b, _c, _d, _e;
    try {
        const res = {};
        const simplePhone = (_b = (_a = data === null || data === void 0 ? void 0 : data.fields) === null || _a === void 0 ? void 0 : _a.SIMPLEPHONE[0]) === null || _b === void 0 ? void 0 : _b.fields;
        if (simplePhone) {
            let layout = "";
            let display = null;
            let belowPrice = null;
            let mock = false;
            const phoneOne = {};
            const textOne = {};
            const c2c = {
                textOne: {},
                textTwo: {},
                buttonOne: {},
            };
            // LAYOUT
            layout = ((_c = data === null || data === void 0 ? void 0 : data.fields) === null || _c === void 0 ? void 0 : _c.layout) || "small-phone";
            mock = layout === "big-phone" ? mock_big_phone_json_1.default : mock_small_phone_json_1.default;
            if (simplePhone === null || simplePhone === void 0 ? void 0 : simplePhone.buttonType) {
                phoneOne.fontType = simplePhone === null || simplePhone === void 0 ? void 0 : simplePhone.buttonType;
            }
            if (simplePhone === null || simplePhone === void 0 ? void 0 : simplePhone.phoneNumber) {
                phoneOne.text = simplePhone === null || simplePhone === void 0 ? void 0 : simplePhone.phoneNumber;
            }
            if (simplePhone === null || simplePhone === void 0 ? void 0 : simplePhone.phoneText) {
                phoneOne.alternativeText = simplePhone === null || simplePhone === void 0 ? void 0 : simplePhone.phoneText;
            }
            // GLOBAL PROPS
            res.layout = layout || mock.layout;
            display = ((_d = data === null || data === void 0 ? void 0 : data.fields) === null || _d === void 0 ? void 0 : _d.visible) || true;
            if (display === "false") {
                res.display = false;
            }
            else {
                res.display = true;
            }
            belowPrice = ((_e = data === null || data === void 0 ? void 0 : data.fields) === null || _e === void 0 ? void 0 : _e.showBelowPrice) || "false";
            if (belowPrice === "false") {
                res.belowPrice = false;
            }
            else {
                res.belowPrice = true;
            }
            // TEXT PROPS
            if (simplePhone.textSubClaim) {
                res["Text-3"] = Object.assign(Object.assign({}, mock["Text-3"]), { text: simplePhone.textSubClaim });
            }
            if (simplePhone === null || simplePhone === void 0 ? void 0 : simplePhone.fontType) {
                textOne.fontType = simplePhone === null || simplePhone === void 0 ? void 0 : simplePhone.fontType;
            }
            if (simplePhone === null || simplePhone === void 0 ? void 0 : simplePhone.label) {
                let finalText = simplePhone === null || simplePhone === void 0 ? void 0 : simplePhone.label;
                if (simplePhone === null || simplePhone === void 0 ? void 0 : simplePhone.phoneNumber) {
                    finalText = finalText.replace("{{phone_number}}", simplePhone === null || simplePhone === void 0 ? void 0 : simplePhone.phoneNumber);
                    textOne.color = "grey6";
                }
                textOne.text = finalText;
            }
            if (simplePhone === null || simplePhone === void 0 ? void 0 : simplePhone.c2cText) {
                c2c.textOne.text = simplePhone.c2cText;
            }
            if (simplePhone === null || simplePhone === void 0 ? void 0 : simplePhone.c2c) {
                c2c.textTwo.text = simplePhone === null || simplePhone === void 0 ? void 0 : simplePhone.c2c;
            }
            if (simplePhone === null || simplePhone === void 0 ? void 0 : simplePhone.c2cButton) {
                c2c.buttonOne.label = simplePhone === null || simplePhone === void 0 ? void 0 : simplePhone.c2cButton;
            }
            if (simplePhone === null || simplePhone === void 0 ? void 0 : simplePhone.titleMobile) {
                phoneOne.titleMobile = simplePhone === null || simplePhone === void 0 ? void 0 : simplePhone.titleMobile;
            }
            // button
            res["Button-1"] = Object.assign(Object.assign({}, mock["Button-1"]), { label: simplePhone === null || simplePhone === void 0 ? void 0 : simplePhone.titleButtonMobile });
            // text one
            res["Text-1"] = Object.assign(Object.assign({}, mock["Text-1"]), textOne);
            res["TextMobile-1"] = Object.assign(Object.assign({}, mock["TextMobile-1"]), { text: simplePhone === null || simplePhone === void 0 ? void 0 : simplePhone.titleMobile });
            // icon
            res["Glyph-1"] = Object.assign(Object.assign({}, mock["Glyph-1"]), { id: simplePhone === null || simplePhone === void 0 ? void 0 : simplePhone.icon });
            // text two
            res["Text-2"] = Object.assign(Object.assign({}, mock["Text-2"]), { text: simplePhone === null || simplePhone === void 0 ? void 0 : simplePhone.subTitle });
            // phone one
            res["Phone-1"] = Object.assign(Object.assign({}, mock["Phone-1"]), phoneOne);
            res["C2C-Modal"] = {
                "Text-1": Object.assign(Object.assign({}, mock["C2C-Modal"]["Text-1"]), c2c.textOne),
                "Text-2": Object.assign(Object.assign({}, mock["C2C-Modal"]["Text-2"]), c2c.textTwo),
                "Button-1": Object.assign(Object.assign({}, mock["C2C-Modal"]["Button-1"]), c2c.buttonOne),
            };
        }
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.simplePhoneNormalizer = simplePhoneNormalizer;
exports.default = exports.simplePhoneNormalizer;
//# sourceMappingURL=index.js.map